const suppliers = { bw:'Bestway', bk:'Booker', pf:'Parfetts' };
export const QUEUE_KEY = 'siq_supplier_order_queue';
export const pauseBetweenAdds = (random = Math.random) => 1500 + Math.floor(random() * 2001);

export function buildSupplierOrderPlan(products, choices, recommended, order) {
  const errors = [];
  const items = products.map(product => {
    const line = order.find(line => line.barcode === product.barcode);
    const manual = choices[product.barcode];
    const key = manual || recommended(product);
    const supplier = suppliers[key];
    const offer = line?.offers?.[supplier];
    const quantity = Number(product.qty);
    if (!line || !supplier || offer?.status !== 'ok' || offer.stockStatus === 'outOfStock' || !(Number(offer.price) > 0))
      errors.push(`${product.name}: no in-stock priced offer is selected.`);
    else if (!Number.isInteger(quantity) || quantity < 1 || quantity > 99)
      errors.push(`${product.name}: choose between 1 and 99 cases in your draft.`);
    else if (offer.basketAddSupported === false)
      errors.push(`${product.name}: basket additions for ${supplier} are not enabled yet.`);
    else if (!manual && !line.cheapest?.supplier)
      errors.push(`${product.name}: ${line.cheapest?.reason || 'scan again for a driver eligibility decision'}; select a supplier explicitly.`);
    else if (!manual && line.cheapest.supplier !== supplier)
      errors.push(`${product.name}: the driver selected ${line.cheapest.supplier}; select a supplier explicitly to change it.`);
    return { barcode:product.barcode, name:offer?.name || product.name, supplier, quantity, price:Number(offer?.price) || 0, packSize:offer?.packSize || '', status:'queued' };
  });
  if (!items.length) errors.push('Scan items into your draft before adding supplier orders.');
  return {items, errors};
}

export async function runSupplierOrderQueue(items, {add, wait, onProgress, shouldStop, random = Math.random}) {
  const progress = items.map(item => ({...item}));
  for (let index = 0; index < progress.length; index++) {
    if (shouldStop()) break;
    if (index > 0) {
      await wait(pauseBetweenAdds(random));
      if (shouldStop()) break;
    }
    progress[index].status = 'adding';
    onProgress(progress.map(item => ({...item})));
    try {
      const result = await add(progress[index]);
      progress[index].result = result;
      progress[index].status = result?.status === 'added' ? 'added' : 'check';
      progress[index].message = result?.message || 'The basket result needs checking.';
    } catch (error) {
      progress[index].status = 'check';
      progress[index].message = error.message || 'The add outcome is unknown. Check the supplier basket.';
    }
    onProgress(progress.map(item => ({...item})));
    if (progress[index].status !== 'added') break;
  }
  return progress;
}

export function loadSupplierOrderQueue() {
  try {
    const items = JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]');
    return Array.isArray(items) ? items.map(item => item.status === 'adding'
      ? {...item,status:'check',message:'This action was interrupted. Check the supplier basket before starting another batch.'} : item) : [];
  } catch { return []; }
}
